import { isEmptyFields } from "../../../../helpers/helper";
import { PlusIcon } from "../../../../components/Icons/Icons";
import Input from "../../../../components/Input/Input";
import Calendar from "../../../../components/Calendar/Calendar";
import DynamicExperianFields from "../DynamicExperianFields";
import ModalComponent from "../../../../components/Modal/Modal";
import React from "react"

const ManualCreditReportModal = ({
                                   isFirstModalPage,
                                   debts,
                                   isManualMode,
                                   popupOnRequest = false,
                                   creditReport,
                                   errors,
                                   fields,
                                   setFields,
                                   setErrors,
                                   handleInputChange,
                                   createCreditReport,
                                   createDebts,
                                   initialFieldSet,
                                   showFieldErrors = false,
                                   revealErrors = false,
                                   triggerCloseModal = false,
                                   rules = null,
                                 }) => {
  return (
    <div>
      <ModalComponent
        modalButtonTitle="Save"
        buttonType="outlined"
        buttonTitleStyle="flex justify-center"
        title={isFirstModalPage ? "Create Report" : "Create Debts"}
        disableCloseFunctionButton={isFirstModalPage || showFieldErrors}
        triggerCloseModal={triggerCloseModal}
        functionButton={isFirstModalPage ? () => createCreditReport() : () => createDebts()}
        customScroll={true}
        openedModal={popupOnRequest ? false : isManualMode && debts.length <= 0}
        hideCloseButtons={popupOnRequest ? false : true}
        disabled={
          isFirstModalPage
            ? isEmptyFields(creditReport?.creditScore) ||
            isEmptyFields(creditReport?.reportDate) ||
            isEmptyFields(creditReport?.fullName)
            : showFieldErrors
              ? false
              : errors?.some((err) => Object.keys(err).length > 0)
        }
        buttonTitle={
          <span className="flex items-center gap-2 whitespace-nowrap">
            <PlusIcon fill="currentColor" />
            Add Credit Line
          </span>
        }
      >
        {isFirstModalPage ? (
          <div className="flex flex-col gap-4">
            <Input
              classes="h-12"
              label="Full Name"
              placeholder=""
              value={creditReport?.fullName || ""}
              onChange={(e) => handleInputChange("fullName", e.target.value)}
            />
            <Calendar
              height="44px"
              label="Report Date"
              placeholder=""
              value={creditReport?.reportDate || ""}
              onChange={(date) => handleInputChange("reportDate", date)}
            />
            <Input
              type="number"
              classes="h-12"
              label="Credit Score"
              placeholder=""
              value={creditReport?.creditScore || ""}
              onChange={(e) => handleInputChange("creditScore", e.target.value?.replace(/[.,]/g, ''))}
            />
          </div>
        ) : (
          <DynamicExperianFields
            setFields={setFields}
            fields={fields}
            errors={errors}
            setErrors={setErrors}
            initialFieldSet={initialFieldSet}
            showFieldErrors={showFieldErrors}
            revealErrors={revealErrors}
            rules={rules}
          />
        )}
      </ModalComponent>
    </div>
  );
};

export default ManualCreditReportModal;
